var TimeoutMaxValue;
(function (TimeoutMaxValue) {
    TimeoutMaxValue[TimeoutMaxValue["maximumDelay"] = 2100000000] = "maximumDelay";
})(TimeoutMaxValue || (TimeoutMaxValue = {}));

export { TimeoutMaxValue };
